<template>
  <router-link
    :to="to"
    :draggable="false"
    replace
  >
    <div
      :class="{
        'transition-all duration-300 h-full': true,
        'bg-white border-[1px] border-[#E5E5E5] rounded-[14px] p-[16px] text-[#626262]': true,
        'hover:border-[#F95031] [&:hover>div>span]:bg-[#F95031]/40': true,
        'flex flex-col items-start justify-between': true,
        'border-[#F95031]': active,
      }"
    >
      <div class="w-full flex items-center justify-between gap-[10px] mb-[16px]">
        <div class="flex items-center gap-[10px]">
          <div
            class="size-[32px] rounded-[8px] flex items-center justify-center"
            :class="icon.containerClass"
          >
            <img
              :src="icon.src"
              width="20"
              height="20"
            >
          </div>
          <p class="mb-0 text-[14px]">
            {{ title }}</p>
        </div>
        <Button
          type="ghost"
          class="px-0"
        >
          <img
            src="https://storage.googleapis.com/komerce/icon/arrow-up-right.svg"
            width="20"
            height="20"
          >
        </Button>
      </div>
      <slot name="footer">
        <span
          :class="{
            'select-text cursor-text': true,
            'text-black text-[24px] font-[600]': !loading,
            'bg-gray-200 rounded-[8px] h-[21px] animate-pulse w-[76%]': loading,
          }"
          @click.prevent.stop
        >
          {{ loading ? '' : transaction | rupiah }}
        </span>
      </slot>
    </div>
  </router-link>
</template>

<script>
import { Button } from '@/@core/components/ui'

/**
 * Component card untuk menampilkan tipe transaksi
 * @component TransactionTypeCard
 */
export default {
  components: {
    Button,
  },
  props: {
    /** @type {string} Judul card transaksi */
    title: {
      type: String,
      required: true,
    },
    /** @type {string} Route tujuan saat card diklik */
    to: {
      type: String,
      default: '',
    },
    /** @type {boolean} Status aktif card */
    active: {
      type: Boolean,
      default: false,
    },
    transaction: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: Object,
      default: () => ({
        src: 'https://storage.googleapis.com/komerce/icon/switch.svg',
        containerClass: 'bg-[#EFF6FF]',
      }),
    },
  },
}
</script>
